<script setup lang="ts">
import { currentIcon } from '~/client/elements'

import Courier from '@/components/Courier.vue'

import type { Location } from '~/client/types'

const location = defineModel<Location>('location', { required: true })
</script>

<template>
	<div class="__selected">
		<div class="__header">
			<img class="__icon" :src="currentIcon" alt="icon" />
			<h3 class="__title" :title="location?.name">{{ location?.name }}</h3>
		</div>
		<Courier :location="location" />
	</div>
</template>
